export const MATCH_MEDIA =
    'only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)';

/**
 * Function to detect retina display
 * */
export function getIsRetinaDisplay() {
    if (window.matchMedia) {
        const mq = window.matchMedia(MATCH_MEDIA);
        return (mq && mq.matches) || window.devicePixelRatio > 1;
    }
    return false;
}
